module.exports = __webpack_public_path__ + "assets/icon-flag-as-inappropriate-deselected.872342fd.svg";